import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private authService: AuthService,
    private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.authService.userAuthenticated.next(this.authService.isAuthenticated());
    let login = JSON.parse(localStorage.getItem("login"))
    if (!this.authService.isAuthenticated()) {
      sessionStorage.setItem('LastRoute', state.url.toString());
      this.router.navigateByUrl('/login', { replaceUrl: true });
      return false;
    }

    if ((login.role == 'SUPER' || login.role == 'FRANCHISE_OWNER') && (!login.providesAccess || login.subscription.organizationStatus == "DELINQUENT" || login.subscription.organizationStatus == "INACTIVE") && state.url != "/change-subscription") {
      this.router.navigateByUrl('/change-subscription', { replaceUrl: true });
      return false;
    }

    // if(!login?.providesAccess && login?.role === "SUPER" && state.url != "/change-subscription"){
    //   this.router.navigateByUrl('/change-subscription', { replaceUrl: true });
    //   return false;
    // }
    return true;
  }
}
